import type { Tenant } from '../payload-types'

/** Helper URL/canonical per-tenant. Permalink articolo = /{slug}/ (come WP). */
export const siteUrl = (t: Pick<Tenant, 'primaryDomain'>) => `https://${t.primaryDomain}`
export const absoluteUrl = (t: Pick<Tenant, 'primaryDomain'>, path: string) =>
  `${siteUrl(t)}${path.startsWith('/') ? path : `/${path}`}`
/** Nome della testata: `brand.siteName` se c'è, altrimenti il nome interno del tenant. */
export const siteName = (t: Pick<Tenant, 'name' | 'brand'>): string => t.brand?.siteName?.trim() || t.name
export const postUrl = (t: Pick<Tenant, 'primaryDomain'>, slug: string) => `${siteUrl(t)}/${slug}/`
export const categoryUrl = (t: Pick<Tenant, 'primaryDomain'>, slug: string) => `${siteUrl(t)}/categoria/${slug}/`
export const authorUrl = (t: Pick<Tenant, 'primaryDomain'>, slug: string) => `${siteUrl(t)}/autore/${slug}/`
/** L'indice delle firme: plurale, accanto al singolare `/autore/<slug>/` del profilo. */
export const AUTHORS_PATH = '/autori/'
export const authorsUrl = (t: Pick<Tenant, 'primaryDomain'>) => absoluteUrl(t, AUTHORS_PATH)
